export interface ClosingChecklistItem {
  id: string;
  labelKey: string;
  requiresDocument: boolean;
}

export const SALE_CLOSING_CHECKLIST: ClosingChecklistItem[] = [
  { id: 'buyer_docs', labelKey: 'detail.closing.buyerDocs', requiresDocument: true },
  { id: 'seller_docs', labelKey: 'detail.closing.sellerDocs', requiresDocument: true },
  { id: 'contract_signed', labelKey: 'detail.closing.contractSigned', requiresDocument: true },
  { id: 'payment_confirmed', labelKey: 'detail.closing.paymentConfirmed', requiresDocument: false },
  { id: 'deed_registered', labelKey: 'detail.closing.deedRegistered', requiresDocument: true },
];

export const RENTAL_CLOSING_CHECKLIST: ClosingChecklistItem[] = [
  { id: 'tenant_docs', labelKey: 'detail.closing.tenantDocs', requiresDocument: true },
  { id: 'landlord_docs', labelKey: 'detail.closing.landlordDocs', requiresDocument: true },
  { id: 'lease_signed', labelKey: 'detail.closing.leaseSigned', requiresDocument: true },
  { id: 'guarantee_attached', labelKey: 'detail.closing.guaranteeAttached', requiresDocument: true },
  { id: 'keys_delivered', labelKey: 'detail.closing.keysDelivered', requiresDocument: false },
];
